import HCLTreeVertexValue from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import Constant, { ConstantJSON } from '../../HCLTreeVertexValue/Constant';
import Label, { LabelJSON } from '../../HCLTreeVertexValue/Label';

export interface HouseEventVertexValueJSON {
  label: LabelJSON;
  constant: ConstantJSON;
}

class HouseEventVertexValue extends HCLTreeVertexValue {
  private constant: Constant;

  /**
   * @param {Label} label
   * @param {Constant} constant
   */
  constructor(label?: Label, constant?: Constant) {
    super(label || new Label('House Event', ''));
    this.constant = constant || new Constant(true);
  }

  /**
   * @returns {Constant}
   */
  getConstant(): Constant {
    return this.constant;
  }

  /**
   * @param {Constant} constant
   */
  setConstant(constant: Constant): void {
    this.constant = constant;
  }


  getFormattedSubLabel(): string {
    return this.getConstant().getValue() ? 'ON' : 'OFF';
  }

  /**
   * @override
   * @returns {HouseEventVertexValueJSON} - dictionary object that describes this
   */
  toJSON(): HouseEventVertexValueJSON {
    return ({
      ...super.toJSON(),
      constant: this.constant.toJSON(),
    });
  }

  clone(): HouseEventVertexValue {
    return new HouseEventVertexValue(this.label.clone(), this.constant.clone());
  }
}

export default HouseEventVertexValue;
